var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PartnerPage',{attrs:{"title":"CRM","doc":_vm.doc}})
}
var staticRenderFns = []

export { render, staticRenderFns }